import "react-phone-number-input/style.css";

import PhoneInput from "react-phone-number-input";
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { FormikTouched } from "formik";

import classes from "./PhoneInputField.module.scss";

type PhoneInputFieldProps = {
  className?: string;
  field: {
    name: string;
    value: any;
  };
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
    handleBlur: {
      (e: React.FocusEvent<any>): void;
      <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
    };
    touched: FormikTouched<Record<string, any>>;
  };
  label: string;
  country: string;
  onChange?: (value: any) => void;
};

const PhoneInputField = (props: PhoneInputFieldProps) => {
  const {
    className,
    field: { name, value },
    form: { setFieldValue, handleBlur },
    label,
    country,
    onChange,
  } = props;

  const onValueChange = (phoneNumber: string) => {
    setFieldValue(name, phoneNumber);

    if (onChange) {
      onChange(phoneNumber);
    }
  };

  const handleInputBlur = (e: any) => {
    handleBlur(e);
  };

  return (
    <div className={`${className} ${classes.input}`}>
      <PhoneInput
        placeholder={label}
        name={name}
        value={value}
        onChange={onValueChange}
        onBlur={handleInputBlur}
        country={country}
        defaultCountry="US"
      />
    </div>
  );
};

export default PhoneInputField;
